module.exports = __webpack_public_path__ + "static/img/django.b9a4e70a.png";